import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/$locale/employer/$companyId')({
  ssr: false,
})
